<script setup>
import { onMounted, ref } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useModals } from "@/utils/useModals";
import { policyUrl, rulesUrl, agreementUrl } from "@/utils/provider";

const { openModal } = useModals();

const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();

const footerRef = ref(null);

onMounted(async () => {
	storeScroll.footer = footerRef.value;
});
</script>
<template>
	<footer class="footer" ref="footerRef">
		<div class="footer__container">
			<div class="footer__item">
				<span class="footer__date">2025</span>
			</div>
			<div class="footer__item">
				<a class="footer__link" target="_blank" rel="noopener noreferrer" :href="agreementUrl">Политика конфиденциальности</a>
			</div>
			<div class="footer__item">
				<a class="footer__link" target="_blank" rel="noopener noreferrer" :href="rulesUrl">Правила конкурса</a>

			</div>
		</div>
	</footer>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.footer {
	position: relative;
	padding: 2.4rem var(--padding-container) 2.6rem;
	background: var(--red);

	font-weight: 300;
	font-size: 1.6rem;
	line-height: 130%;
	color: var(--white);
	@media (max-width: vars.$xx) {
		padding: 1.7rem var(--padding-container) 1.9rem;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.4rem;
	}
}
.footer__container {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1rem;
	@media (max-width: vars.$xx) {
		grid-template-columns: 1fr;
		text-align: center;
		gap:0.4rem;
	}
	@media (max-width: vars.$x480) {
	}
}
.footer__item {
	justify-self: center;
	&:first-child {
		justify-self: start;
		@media (max-width: vars.$xx) {
			justify-self: center;
		}
	}
	&:last-child {
		justify-self: end;
		@media (max-width: vars.$xx) {
			justify-self: center;
		}
	}
}
.footer__link {
	color: currentColor;
	border-bottom: 1px solid transparent;
	@media (hover: hover) {
		&:hover {
			border-color: currentColor;
		}
	}
	
}
</style>
